import {StyleSheet, View} from 'react-native';
import React, {useState} from 'react';
import fontWeightToFamily from '@/Assets/Fonts/fontWeightToFamily';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import ChessboardWithArrow from '@/Components/ChessboardWithArrow';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import ProgressMultiColorBar from '../ProgressMultiColorBar/ProgressMultiColorBar';
import ProgressBar from '@/Atoms/ProgressBar';

interface ChessBoardCoachCardProps {
  id: number;
  fen: string;
  puzzleName: string;
  orientation: string;
  avgAttempts: string;
  avgSolveTime: string;
  puzzleTime: string;
  solvedPercentage: string;
  notAttemptedPercentage: string;
  solvedWithHintPercentage: string;
  notSolvedPercentage: string;
}

const ChessBoardCoachCard: React.FC<ChessBoardCoachCardProps> = ({
  id,
  fen,
  puzzleName,
  orientation,
  avgAttempts,
  avgSolveTime,
  puzzleTime,
  solvedPercentage,
  notAttemptedPercentage,
  solvedWithHintPercentage,
  notSolvedPercentage,
}) => {
  const defaultFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

  // const [tooltip, setTooltip] = useState({
  //   visible: false,
  //   x: 0,
  //   y: 0,
  // });

  // const segments = [
  //   {
  //     progress: parseInt(solvedPercentage) / 100,
  //     color: CCColors.Green,
  //     label: 'Solved',
  //   },
  //   {
  //     progress: parseInt(solvedWithHintPercentage) / 100,
  //     color: CCColors.Blue,
  //     label: 'Solved with Hint',
  //   },
  //   {
  //     progress: parseInt(notSolvedPercentage) / 100,
  //     color: CCColors.Red,
  //     label: 'Not Solved',
  //   },
  //   {
  //     progress: parseInt(notAttemptedPercentage) / 100,
  //     color: CCColors.BrightYellow,
  //     label: 'Not Attempted',
  //   },
  // ];

  // const handlePointerMove = e => {
  //   setTooltip({
  //     visible: true,
  //     x: e.pageX - 50,
  //     y: e.pageY - 250,
  //   });
  // };

  // const handlePointerLeave = () => {
  //   setTooltip(prev => ({...prev, visible: false}));
  // };

  const getAttemptsColor =
    parseInt(avgAttempts, 10) < 4 && parseInt(avgAttempts, 10) > 0.9
      ? CCColors.Green
      : CCColors.Red;

  return (
    <Box key={id} style={[styles.container, {position: 'relative'}]}>
      <View style={styles.boardContainer}>
        <ChessboardWithArrow
          position={fen || defaultFen}
          handleNewFen={() => {}}
          lastMoveFen={fen || defaultFen}
          boardOrientation={orientation}
          disabled={true}
        />
      </View>

      <Box style={styles.infoContainer}>
        <View style={styles.puzzleHeader}>
          <CCText style={styles.title} numberOfLines={1} ellipsizeMode={'tail'}>
            {puzzleName}
          </CCText>
        </View>

        <Box style={styles.infoBox}>
          <View style={styles.statusContainer}>
            <Box style={styles.progressBarBox}>
              <CCText style={styles.progressBarText}>Solved{'        '}</CCText>
              <ProgressBar
                progress={parseInt(solvedPercentage) / 100}
                style={styles.progressBar}
                fillStyle={{
                  backgroundColor: CCColors.Green,
                }}
              />
              <CCText style={styles.progressBarText}>
                {'     '}
                {solvedPercentage}%
              </CCText>
            </Box>
            <Box style={styles.progressBarBox}>
              <CCText style={styles.progressBarText}>Solved Hint{'   '}</CCText>
              <ProgressBar
                progress={parseInt(solvedWithHintPercentage) / 100}
                style={styles.progressBar}
                fillStyle={{
                  backgroundColor: CCColors.Blue,
                }}
              />
              <CCText style={styles.progressBarText}>
                {'     '}
                {solvedWithHintPercentage}%
              </CCText>
            </Box>
            <Box style={styles.progressBarBox}>
              <CCText style={styles.progressBarText}>Not Attempted </CCText>
              <ProgressBar
                progress={parseInt(notAttemptedPercentage) / 100}
                style={styles.progressBar}
                fillStyle={{
                  backgroundColor: CCColors.BrightYellow,
                }}
              />
              <CCText style={styles.progressBarText}>
                {'     '}
                {notAttemptedPercentage}%
              </CCText>
            </Box>
            <Box style={styles.progressBarBox}>
              <CCText style={styles.progressBarText}>Not Solved{'    '}</CCText>
              <ProgressBar
                progress={parseInt(notSolvedPercentage) / 100}
                style={styles.progressBar}
                fillStyle={{
                  backgroundColor: CCColors.Red,
                }}
              />
              <CCText style={styles.progressBarText}>
                {'     '}
                {notSolvedPercentage}%
              </CCText>
            </Box>
            {/* <ProgressMultiColorBar
              segments={segments}
              height={5}
              //borderColor="#333"
              // borderWidth={0.1}
              // onPointerMove={handlePointerMove}
              // onPointerLeave={handlePointerLeave}
            /> */}
          </View>
          {/* ✅ Tooltip OUTSIDE statusContainer
          {tooltip.visible && (
            <View
              style={{
                position: 'absolute',
                top: tooltip.y,
                left: tooltip.x,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 6,
                borderRadius: 4,
                zIndex: 9999,
                pointerEvents: 'none',
              }}>
              {segments.map(
                (segment, index) =>
                  segment.label && (
                    <CCText
                      key={index}
                      fontSize={FontSizes[12]}
                      color={CCColors.White}
                      style={{paddingVertical: 2}}>
                      {segment.label}: {Math.round(segment.progress * 100)}%
                    </CCText>
                  ),
              )}
            </View>
          )} */}
          <View style={styles.bottomInfoRow}>
            <CCText fontSize={FontSizes[12]}>
              Avg. Attempts:{' '}
              <CCText fontWeight="bold" color={getAttemptsColor}>
                {avgAttempts}
              </CCText>
            </CCText>

            <View style={styles.clockContainer}>
              <Icon name="clock-outline" size={14} color={CCColors.Green} />
              <CCText style={styles.clockText} fontSize={FontSizes[12]}>
                {avgSolveTime ? (
                  avgSolveTime
                ) : (
                  <CCText fontWeight="bold" color={CCColors.Red}>
                    NA
                  </CCText>
                )}
                /{puzzleTime}s
              </CCText>
            </View>
          </View>
        </Box>
      </Box>
    </Box>
  );
};

export default ChessBoardCoachCard;

const styles = StyleSheet.create({
  container: {
    width: 250,
    backgroundColor: CCColors.White,
    borderRadius: 8,
    padding: 4,
    margin: 5,
    border: `1px solid ${CCColors.Border}`,
    alignItems: 'center',
  },
  boardContainer: {
    width: '100%',
    maxWidth: 240,
    // paddingTop: 10,
    padding: 5,
    backgroundColor: CCColors.BrightYellow,
    justifyContent: 'center',
    aspectRatio: 1,
    flexShrink: 0,
  },
  infoContainer: {
    padding: 2,
    width: '100%',
    alignItems: 'center',
  },
  puzzleHeader: {
    alignItems: 'center',
  },
  title: {
    fontSize: FontSizes[16],
    fontWeight: '600',
    color: CCColors.TextColor.Dark,
    textTransform: 'capitalize',
    lineHeight: 30,
    maxWidth: 230,
    overflow: 'hidden',
    justifyContent: 'center',
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: CCColors.BorderBottom,
    borderRadius: 4,
    paddingHorizontal: 5,
    width: '100%',
  },
  statusContainer: {
    // paddingTop: 6,
    padding: 3,
    // flexDirection: 'row',
    alignItems: 'center',
  },
  statusMessage: {
    fontSize: FontSizes[14],
    padding: 3,
  },
  bottomInfoRow: {
    paddingHorizontal: 3,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 2,
  },
  clockContainer: {
    flexDirection: 'row',
  },
  clockText: {
    paddingLeft: 4,
  },
  progressBarBox: {
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'space-between',
    width: '100%',
  },
  progressBar: {
    width: '45%',
    height: 4,
    backgroundColor: 'rgba(38, 35, 34, 0.1)',
  },
  progressBarText: {
    fontSize: FontSizes[10],
    minWidth: 75,
  },
});
